import $ from 'jquery';

const SELECTOR = '.title--with-deco';
const WIDTH_MIN = 5;
const WIDTH_MAX = 12;
const HEIGHT_MIN = 80;
const HEIGHT_MAX = 180;
const MAX_Y_OFFSET = 40;

function getRandomArbitrary(min, max) {
  return Math.random() * (max - min) + min;
}
function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export default class TitleDeco {
  constructor($context) {
    $(SELECTOR).each((i, el) => {
      this.createDeco($(el));
    });
  }

  createDeco($el) {
    const color_classes = [
      'title-deco__col1',
      'title-deco__col2',
      'title-deco__col3'
    ];

    const anim_classes = [
      'title-deco__anim1',
      'title-deco__anim2',
      'title-deco__anim3',
      'title-deco__anim4'
    ];
    const $wrap = $('<div class="title-deco" />');
    let left = 0;
    for (let i = 0; i < 3; i++) {
      const $item = $('<div />');
      // Take one random class of each and remove it from array.
      const col = color_classes.splice(Math.floor(Math.random()*color_classes.length), 1);
      const anim = anim_classes.splice(Math.floor(Math.random()*anim_classes.length), 1);
      const width = getRandomInt(WIDTH_MIN, WIDTH_MAX);
      $item.css({
        width,
        left,
        height: getRandomInt(HEIGHT_MIN, HEIGHT_MAX),
        top: getRandomInt(0, MAX_Y_OFFSET)
      }).addClass(`title-deco__item ${col} ${anim}`);

      left += width;
      if (Math.random() < 0.7) {
        left += getRandomInt(4, 10);
      }

      $wrap.append($item);
    }

    $el.append($wrap);
  }
}



// WEBPACK FOOTER //
// ./3.modules/titleDeco/TitleDeco.js